import { schema } from 'normalizr';
import memberSchema from './member';

const pulseSurveyResponseSchema = new schema.Entity('pulseSurveyResponses', {
  member: memberSchema,
});

export default pulseSurveyResponseSchema;
